import React from 'react';
import { connect } from 'react-redux';
import Menu from '../../../../../assets/images/more-dots.svg';
import PopupMenu from '../../../../../components/PopupMenu';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import './CommentCard.scss';

// Change Card to the appropriate name
class CommentCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { menu: null };
  }

  componentDidMount() {
  }

  handleCloseMenu() {
    this.setState({ menu: null });
  }

  handleMenuSelection(type) {
    this.handleCloseMenu();
    const { handleMenuSelected, menuOptions } = this.props;
    if (handleMenuSelected) {
      for (var i = 0; i < menuOptions.length; i++) {
        if (menuOptions[i].type == type) {
          handleMenuSelected(menuOptions[i]);
          break;
        }
      }
    }
  }

  createMoreMenu() {
    const { menuOptions } = this.props;

    const menu = <PopupMenu right={10} top={41} width={150} menuOptions={menuOptions} size="smaller"
      menuId="userMenu" popupOnHover={false} handleMenuSelection={this.handleMenuSelection}
      handleClickAway={this.handleCloseMenu} />;
    return menu;
  }

  handleClick() {
    const { handleMenuClick, data, menuOptions } = this.props;
    if (handleMenuClick) {
      handleMenuClick(data);
    }
    else if (menuOptions) {
      if (!this.state.menu) {
        const menu = this.createMoreMenu();
        this.setState({ menu: menu });
      }
    }
  }

  handleSelection() {
    const { handleCardSelection, data } = this.props;
    if (handleCardSelection) {
      handleCardSelection(data);
    }
  }

  render() {
    const { top, right, width, height, caption, date, hideDots, turnOffBorder, selected } = this.props;
    const { menu } = this.state;

    let menuDots = hideDots ? null : <img className="menu-dots" alt="menu" src={Menu} onMouseDown={this.handleClick} />;
    let style = { top: top + 'px', width: width + 'px', height: height + 'px' };
    if (right != undefined) {
      style.right = right + 'px';
    }

    let userImage = null;
    return (
      <div className={'comment-card ' + (turnOffBorder ? 'borderless' : '') + (selected ? ' selected' : '')} style={style} onClick={this.handleSelection}>
        {menu}
        {userImage}
        <p className="comment-caption" >{caption}</p>
        <p className="comment-date">{date}</p>
        {menuDots}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CommentCard);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/SubHeader/CommentCard/index.js